// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"PageContainerComponent_pageContainer__2RN6p"};